import _slicedToArray from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\nanma\\Documents\\GitHub\\star\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["## Imports"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["<span style=\"background:#cccccc;color:", ";\">", "</span>"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\nThis notebook only makes sense in the context of [Observable vZome][1].\nThe goal is to create a generic strut shape for an orbit not known in advance.\nIn [vZome][2], such struts are always rendered in white.\nFor known orbits, the strut shapes have been modeled manually.\n\nWe want a simple prismatic shape with a reasonably uniform cross-section.\nThe challenge is to come up with a shape that will serve for any orbit,\nminimally sensitive to the actual direction of the orbit.\n\nSince every field allows octahedral symmetry, we want the richest triangular\ntiling of that symmetry, which means we want the fundamental triangles of\nthe reflection group, by definition.  Rather than rely on any symmetry orbits,\nwe can simply hard-code the vertices of a disdyakis dodecahedron, all\nreflections and permutations of (8,0,0), (4,4,4), and (5,5,0).\n(This is a simple approximation with integers.)\nThese vertices correspond to blue-like, yellow-like, and green-like axes,\nin the usual Zome coloring.\n\n<img src=\"https://user-images.githubusercontent.com/1584024/50730978-410b8880-110e-11e9-8e1a-325c9a2cbf29.png\"/>\n\nFirst, we find the triangle intersected by the orbit prototype vector.\nThere should be only two possibilities, assuming\nthe orbit prototype has been normalized.  Next, we find the centroid of that triangle,\nand the point where the prototype vector intersects the triangle (", ").\nNext, we use the offset from the centroid to the intersection, and offset\nthe entire triangle by the same amount.\nFinally, using the offsetted copy of the ", " edge,\nwe reflect that edge's endpoints through the ", " point, to yield\nthe ", " parallelogram strut cross-section.\n\n[1]: https://beta.observablehq.com/@vorth/observable-vzome-rendering\n[2]: http://vzome.com\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["# A Shape for White Struts"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// https://observablehq.com/@vorth/a-shape-for-white-struts@118
import define1 from "../@vorth/observable-vzome-rendering.js";
import define2 from "../@jrus/zome-arithmetic.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject());
  });
  main.variable(observer()).define(["md", "colorWord"], function (md, colorWord) {
    return md(_templateObject2(), colorWord("black"), colorWord("chartreuse"), colorWord("black"), colorWord("orange"));
  });
  main.variable(observer()).define(["getDefaultShape"], function (getDefaultShape) {
    return getDefaultShape([[-1, 1], [2, -1]]);
  });
  main.variable(observer("getDefaultShape")).define("getDefaultShape", ["grmul", "grfloat", "scalarmul", "vectoradd", "planeFromPoints", "linePlaneIntersection", "vectorsub", "grneg"], function (grmul, grfloat, scalarmul, vectoradd, planeFromPoints, linePlaneIntersection, vectorsub, grneg) {
    //
    //   Strut prism, seen from one end (ntl,ntr,nbr,nbl), the far side of the nearer ball.
    //   This is the even parity orientation.
    //
    //          ntl-----------ntr
    //            |\    A    /|
    //            | \       / |
    //            | ftl---ftr |
    //            |D |     | B|
    //            |  |     |  |
    //            | fbl---fbr |
    //            | /       \ |
    //            |/    C    \|
    //          nbl-----------nbr
    //
    var ftl = 0;
    var ftr = 1;
    var fbl = 2;
    var fbr = 3;
    var ntl = 4;
    var ntr = 5;
    var nbl = 6;
    var nbr = 7;
    var polygons = [[ntl, ntr, ftr, ftl], // A
    [ftr, ntr, nbr, fbr], // B
    [fbl, fbr, nbr, nbl], // C
    [ntl, ftl, fbl, nbl], // D
    [ftl, ftr, fbr, fbl], // far cap
    [ntl, nbl, nbr, ntr]];
    var tip = [ntl, ntr, nbl, nbr];
    var x = 1.0;
    return function getDefaultShape(orbit) {
      var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [1,, 10];
      var prototype = [[1, 0, 1]].concat(orbit);
      var eight = grmul([8], scale);
      var five = grmul([5], scale);
      var four = grmul([4], scale);

      var _orbit$map = orbit.map(grfloat),
          _orbit$map2 = _slicedToArray(_orbit$map, 2),
          y = _orbit$map2[0],
          z = _orbit$map2[1];

      var yellow = [four, four, four]; // find the corner of the octant

      var first, second, third;
      var firstNeg, secondNeg, thirdNeg;
      var blue, green;
      var swapParity = false; // TODO: clean this up; not all these cases are possible, since
      //   the orbit is canonicalized.  There are probably only two choices,
      //   the first two.  X should always be the greatest.

      if (x >= y) {
        if (y >= z) {
          swapParity = true;
          blue = [eight, [], []];
          green = [five, five, []];
        } else if (x >= z) {
          blue = [eight, [], []];
          green = [five, [], five];
        } else {
          swapParity = true;
          blue = [[], eight, []];
          green = [five, [], five];
        }
      } else {
        if (x >= z) {
          blue = [[], eight, []];
          green = [five, five, []];
        } else if (y >= z) {
          swapParity = true;
          blue = [[], eight, []];
          green = [[], five, five];
        } else {
          blue = [[], [], eight];
          green = [[], five, five];
        }
      }

      var centroid = scalarmul([1,, 3], vectoradd(vectoradd(blue, green), yellow));
      var trianglePlane = planeFromPoints(blue, green, yellow);
      var strutCenterline = [[[], [], []], prototype];
      var endCenter = linePlaneIntersection(strutCenterline, trianglePlane);
      var ftl_offset = vectorsub(swapParity ? green : yellow, centroid);
      var fbl_offset = vectorsub(swapParity ? yellow : green, centroid);
      var ftl_v = vectoradd(endCenter, ftl_offset);
      var fbl_v = vectoradd(endCenter, fbl_offset);
      var fbr_v = vectorsub(endCenter, ftl_offset);
      var ftr_v = vectorsub(endCenter, fbl_offset);
      var nbr_v = ftl_v.map(grneg);
      var ntr_v = fbl_v.map(grneg);
      var ntl_v = fbr_v.map(grneg);
      var nbl_v = ftr_v.map(grneg);
      return {
        prototype: prototype,
        vertices: [ftl_v, ftr_v, fbl_v, fbr_v, ntl_v, ntr_v, nbl_v, nbr_v],
        polygons: polygons,
        tip: tip,
        waist: []
      };
    };
  });
  main.variable(observer("planeFromPoints")).define("planeFromPoints", ["vectorsub", "wedge"], function (vectorsub, wedge) {
    return function (v1, v2, v3) {
      var e1 = vectorsub(v1, v2);
      var e2 = vectorsub(v1, v3);
      var normal = wedge(e1, e2);
      return [v1, normal];
    };
  });
  main.variable(observer("linePlaneIntersection")).define("linePlaneIntersection", ["dot", "vectorsub", "grdiv", "vectoradd", "scalarmul"], function (dot, vectorsub, grdiv, vectoradd, scalarmul) {
    return function (line, plane) {
      var _line = _slicedToArray(line, 2),
          lineStart = _line[0],
          lineDirection = _line[1];

      var _plane = _slicedToArray(plane, 2),
          planeCenter = _plane[0],
          planeNormal = _plane[1];

      var denom = dot(planeNormal, lineDirection);
      if (denom[0] == 0 && denom[1] == 0) return undefined;
      var p1p3 = vectorsub(planeCenter, lineStart);
      var numerator = dot(planeNormal, p1p3);
      var u = grdiv(numerator, denom);
      return vectoradd(lineStart, scalarmul(u, lineDirection));
    };
  });
  main.variable(observer("colorWord")).define("colorWord", ["html"], function (html) {
    return function colorWord(name) {
      return html(_templateObject3(), name, name);
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4());
  });
  var child1 = runtime.module(define1);
  main.import("createStrutGeometry", child1);
  var child2 = runtime.module(define2);
  main.import("grfloat", child2);
  main.import("grneg", child2);
  main.import("grsum", child2);
  main.import("grdiv", child2);
  main.import("grmul", child2);
  main.import("wedge", child2);
  main.import("dot", child2);
  main.import("vectorsub", child2);
  main.import("vectoradd", child2);
  main.import("scalarmul", child2);
  return main;
}